import { asAnswersMap } from "features/Library/Common/QuestionsForm/Answers/AnswerProvider";
import { type IAnswer, type IAnswerBase } from "../../../../Common/models";
import { AssessmentSingleTextAnswer } from "../AssessmentFields";
import { type Answer, AssessmentAnswerType } from "../../../types/state";
import { AssessmentMultipleTextAnswer } from "features/Library/Assessments/Details/AssessmentContentForm/AssessmentFields/AssessmentMultipleTextAnswer";

/* istanbul ignore next */
export const AnswersMap = asAnswersMap({
  [AssessmentAnswerType.SingleText]: {
    Component: AssessmentSingleTextAnswer,
    castAnswer: (answer: IAnswerBase) => answer as IAnswer<Answer>,
  },
  [AssessmentAnswerType.MultipleText]: {
    Component: AssessmentMultipleTextAnswer,
    castAnswer: (answer: IAnswerBase) => answer as IAnswer<Answer>,
  },
});
